export default state => state.activeAuthorId;
